/**
 * assets/vip-cancel.js
 *
 * Drives the VIP-membership cancel flow on /pages/membership.
 * Steps map 1:1 to the Figma frames (file: Savvy Smart - VIP Membership Overview):
 *
 *   Step 1  Login prompt          Figma 249:11
 *   Step 2a Cancellation entry    Figma 226:1323   (#vip-modal-entry)
 *   Step 2b Member-info confirm   Figma 227:1353   (#vip-modal-confirm)
 *   Step 3  Save attempt          Figma 227:1456   (#vip-modal-retention)
 *   Step 4  Confirmation          Figma 227:1518   (#vip-modal-success)
 *
 * All API calls go through the Azure Functions app (no WowPay appKey in the
 * browser). Auth model:
 *   - Logged-in shoppers: Shopify renders { email, ts, sig } in data-* attrs
 *     of #vip-cancel-trigger (HMAC of "email|ts" with the shared secret).
 *   - Guests: magic-link → vip-magic-link-verify returns { email, exp, sig }
 *     stored in sessionStorage under SESSION_KEY.
 */

(function () {
  'use strict';

  var SESSION_KEY = 'vipCancel.session.v1';
  var TOKEN_QS    = 'vip_token';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function on(el, evt, fn) { if (el) el.addEventListener(evt, fn); }

  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim()); }

  function readSession() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || !s.email || !s.sig || !s.exp) return null;
      if (Math.floor(Date.now() / 1000) >= Number(s.exp)) {
        sessionStorage.removeItem(SESSION_KEY);
        return null;
      }
      return s;
    } catch (e) { return null; }
  }
  function writeSession(s) { sessionStorage.setItem(SESSION_KEY, JSON.stringify(s)); }
  function clearSession()  { sessionStorage.removeItem(SESSION_KEY); }

  function openModal(el)  { if (!el) return; el.hidden = false; el.classList.add('is-open'); document.body.classList.add('vip-modal-open'); }
  function closeModal(el) { if (!el) return; el.hidden = true;  el.classList.remove('is-open'); }
  function closeAll(root) { $$('.vip-modal', root).forEach(closeModal); document.body.classList.remove('vip-modal-open'); }

  function showError(modal, message) {
    var el = $('.vip-modal__error', modal);
    if (!el) return;
    el.textContent = message || 'Something went wrong, please try again.';
    el.hidden = !message;
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    if (busy) {
      btn.dataset._label = btn.dataset._label || btn.textContent;
      btn.textContent = 'Please wait…';
      btn.disabled = true;
    } else {
      if (btn.dataset._label) btn.textContent = btn.dataset._label;
      btn.disabled = false;
    }
  }

  function formatDate(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) { return iso; }
  }

  function api(base, path, body) {
    var url = String(base || '').replace(/\/+$/, '') + path;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {}),
    }).then(function (res) {
      return res.text().then(function (txt) {
        var data = null;
        try { data = txt ? JSON.parse(txt) : null; } catch (e) { data = { raw: txt }; }
        if (!res.ok) {
          var err = new Error((data && data.error) || ('Request failed (' + res.status + ')'));
          err.status = res.status;
          err.data   = data;
          throw err;
        }
        return data;
      });
    });
  }

  function init(root) {
    var trigger = $('#vip-cancel-trigger', root);
    if (!trigger) return;

    var apiBase = root.getAttribute('data-api-base') || trigger.getAttribute('data-api-base') || '';
    // Strip stray whitespace, non-breaking spaces (U+00A0) and zero-width chars
    // that theme-editor copy/paste sometimes injects and which would otherwise
    // turn the absolute URL into a relative /pages/... path.
    apiBase = apiBase.replace(/[\s\u00A0\u200B-\u200D\uFEFF]+/g, '').trim();
    if (!apiBase) {
      console.warn('[vip-cancel] Missing data-api-base on root or trigger; flow disabled.');
      return;
    }
    if (!/^https?:\/\//i.test(apiBase)) {
      console.warn('[vip-cancel] data-api-base is not an absolute http(s) URL:', JSON.stringify(apiBase));
    }

    var modals = {
      login:     $('#vip-modal-login',     root),
      entry:     $('#vip-modal-entry',     root),
      confirm:   $('#vip-modal-confirm',   root),
      retention: $('#vip-modal-retention', root),
      success:   $('#vip-modal-success',   root),
      kept:      $('#vip-modal-kept',      root),
      error:     $('#vip-modal-error',     root),
    };

    // 'api'  → use WowPay's native retention preview/accept/reject endpoints.
    // 'note' → legacy fallback: record the offer as a subscription note.
    var retentionMode = (root.getAttribute('data-retention-mode') || 'api')
      .replace(/[\s\u00A0\u200B-\u200D\uFEFF]+/g, '').trim().toLowerCase() || 'api';

    // Holds the pending offer ids returned by preview/reject, needed for
    // accept/reject. Reset whenever a new offer is rendered.
    var currentOffer = null;

    // Membership-not-found (404) → show the dedicated support/error screen
    // (Figma 227:1578) instead of leaking the raw "WowPay API error (404)".
    function showErrorModal() {
      closeAll(root);
      openModal(modals.error);
    }

    /* ── Close handlers (× buttons + ESC + backdrop click) ─────────────── */
    $$('.vip-modal', root).forEach(function (m) {
      $$('[data-vip-close]', m).forEach(function (b) { on(b, 'click', function () { closeModal(m); }); });
      on(m, 'click', function (e) { if (e.target === m) closeModal(m); });
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeAll(root); });

    /* ── Step 1: Login modal (guest only) ───────────────────────────────── */
    var loginForm  = $('#vip-login-form',  modals.login);
    var loginEmail = $('#vip-login-email', modals.login);
    var loginSent  = $('.vip-login__sent', modals.login);
    var loginInit  = $('.vip-login__form', modals.login);

    on(loginForm, 'submit', function (e) {
      e.preventDefault();
      showError(modals.login, '');
      var email = (loginEmail.value || '').trim();
      if (!isEmail(email)) { showError(modals.login, 'Please enter a valid email address.'); return; }
      var btn = loginForm.querySelector('[type="submit"]');
      setBusy(btn, true);
      api(apiBase, '/vip-magic-link-request', { email: email })
        .then(function () {
          if (loginInit) loginInit.hidden = true;
          if (loginSent) loginSent.hidden = false;
        })
        .catch(function (err) { showError(modals.login, err.message); })
        .then(function () { setBusy(btn, false); });
    });

    /* ── Step 2a → 2b: load info and render confirm modal ───────────────── */
    function openConfirmFromSession(session) {
      var btn = $('#vip-entry-cancel', modals.entry);
      setBusy(btn, true);
      showError(modals.entry, '');
      api(apiBase, '/vip-info', session)
        .then(function (info) {
          renderConfirm(info);
          closeModal(modals.entry);
          openModal(modals.confirm);
        })
        .catch(function (err) {
          if (err.status === 401) { clearSession(); openModal(modals.login); }
          else if (err.status === 404) { showErrorModal(); }
          else showError(modals.entry, err.message);
        })
        .then(function () { setBusy(btn, false); });
    }

    function renderConfirm(info) {
      modals.confirm.dataset.subscriptionKey = info.subscription.subscriptionKey;
      modals.confirm.dataset.subscriptionId  = info.subscription.id;

      var firstName = (info.member && info.member.firstName) || (info.member && info.member.email && info.member.email.split('@')[0]) || 'there';
      var greet     = $('.vip-confirm__greet', modals.confirm);
      if (greet) greet.textContent = "We're sorry to see you go, " + firstName;

      var emailEl  = $('[data-field="email"]',           modals.confirm);
      var planEl   = $('[data-field="plan"]',            modals.confirm);
      var statusEl = $('[data-field="status"]',          modals.confirm);
      var nextEl   = $('[data-field="nextBillingDate"]', modals.confirm);
      if (emailEl)  emailEl.textContent  = info.member.email;
      if (planEl)   planEl.textContent   = info.subscription.plan;
      if (statusEl) statusEl.textContent = info.subscription.statusName;
      if (nextEl)   nextEl.textContent   = formatDate(info.subscription.nextBillingDate);

      var reasonSelect = $('#vip-cancel-reason', modals.confirm);
      if (reasonSelect && Array.isArray(info.cancelationReasons)) {
        reasonSelect.innerHTML = '<option value="">Reason for cancelling (optional)</option>' +
          info.cancelationReasons.map(function (r) {
            return '<option value="' + r.id + '">' + (r.name || ('Reason #' + r.id)) + '</option>';
          }).join('');
      }

      // If already cancelled, swap the CTAs to inform-only.
      var alreadyCancelled = info.subscription.isCancelled;
      var cancelBtn = $('#vip-confirm-cancel', modals.confirm);
      if (cancelBtn) cancelBtn.disabled = !!alreadyCancelled;
    }

    /* ── Step 2 entry → click "CANCEL MY MEMBERSHIP" ────────────────────── */
    on($('#vip-entry-cancel', modals.entry), 'click', function () {
      var session = currentSession();
      if (!session) { closeModal(modals.entry); openModal(modals.login); return; }
      openConfirmFromSession(session);
    });

    /* ── Step 2b → "CANCEL MY MEMBERSHIP": preview a retention offer ─────── */
    on($('#vip-confirm-cancel', modals.confirm), 'click', function (e) {
      var btn = e.currentTarget;

      // Legacy/static path: skip the API preview, just show the static offer.
      if (retentionMode !== 'api') {
        closeModal(modals.confirm);
        openModal(modals.retention);
        return;
      }

      var session = currentSession();
      if (!session) { closeAll(root); openModal(modals.login); return; }

      setBusy(btn, true);
      showError(modals.confirm, '');
      api(apiBase, '/vip-retention-offer', session)
        .then(function (res) {
          if (res.shouldCancel || !res.offer) {
            // No offer available — proceed straight to cancellation.
            performCancel(btn, modals.confirm);
            return;
          }
          setOffer(res);
          renderRetention(res);
          closeModal(modals.confirm);
          openModal(modals.retention);
          setBusy(btn, false);
        })
        .catch(function (err) {
          setBusy(btn, false);
          if (err.status === 404) { showErrorModal(); }
          else showError(modals.confirm, err.message);
        });
    });

    /* ── Step 2b → "KEEP MY MEMBERSHIP" closes everything ───────────────── */
    on($('#vip-confirm-keep', modals.confirm), 'click', function () { closeAll(root); });

    /* ── Render the retention modal from a preview/reject response ──────── */
    function setOffer(res) {
      currentOffer = res.offer
        ? {
            subscriptionId:                res.subscriptionId,
            pendingSubscriptionDiscountId: res.offer.pendingSubscriptionDiscountId,
            subscriptionGroupDiscountId:   res.offer.subscriptionGroupDiscountId,
          }
        : null;
    }

    function renderRetention(res) {
      var bannerEl = $('.vip-retention__banner', modals.retention);
      if (bannerEl && res.banner) bannerEl.textContent = res.banner;
      var redeemed = $('.vip-retention__redeemed', modals.retention);
      if (redeemed) redeemed.hidden = true;
      showError(modals.retention, '');
    }

    function showRedeemed(message) {
      var msgEl = $('.vip-kept__message', modals.kept);
      if (msgEl && message) msgEl.textContent = message;
      closeAll(root);
      openModal(modals.kept);
    }

    /* ── Step 3 retention → "REDEEM OFFER & STAY" (accept) ──────────────── */
    on($('#vip-retention-redeem', modals.retention), 'click', function (e) {
      e.preventDefault();
      var btn = e.currentTarget;
      var session = currentSession();
      if (!session) { closeAll(root); openModal(modals.login); return; }
      setBusy(btn, true);
      showError(modals.retention, '');

      var path = retentionMode === 'api' ? '/vip-retention-accept' : '/vip-retention-note';
      var payload = retentionMode === 'api'
        ? Object.assign({}, session, {
            pendingSubscriptionDiscountId: currentOffer && currentOffer.pendingSubscriptionDiscountId,
            subscriptionGroupDiscountId:   currentOffer && currentOffer.subscriptionGroupDiscountId,
          })
        : Object.assign({}, session, { offerCode: '50_OFF_3_MONTHS' });

      api(apiBase, path, payload)
        .then(function (res) { showRedeemed(res && res.message); })
        .catch(function (err) { showError(modals.retention, err.message); })
        .then(function () { setBusy(btn, false); });
    });

    /* ── Step 3 retention → "No thanks, continue to cancel" (reject) ────── */
    on($('#vip-retention-decline', modals.retention), 'click', function (e) {
      e.preventDefault();
      var btn = e.currentTarget;

      // Legacy/static path: no reject endpoint, cancel directly.
      if (retentionMode !== 'api') { performCancel(btn, modals.retention); return; }

      var session = currentSession();
      if (!session) { closeAll(root); openModal(modals.login); return; }
      setBusy(btn, true);
      showError(modals.retention, '');
      api(apiBase, '/vip-retention-reject', Object.assign({}, session, {
        pendingSubscriptionDiscountId: currentOffer && currentOffer.pendingSubscriptionDiscountId,
        reason: 'Customer declined the offer',
      }))
        .then(function (res) {
          if (res.shouldCancel || !res.offer) {
            // No more offers — rejecting the final offer is the decision to cancel.
            performCancel(btn, modals.retention);
            return;
          }
          // Escalated offer — show the improved deal and loop.
          setOffer(res);
          renderRetention(res);
          setBusy(btn, false);
        })
        .catch(function (err) { showError(modals.retention, err.message); setBusy(btn, false); });
    });

    function performCancel(btn, errModal) {
      errModal = errModal || modals.retention;
      var session = currentSession();
      if (!session) { closeAll(root); openModal(modals.login); return; }

      var reasonSelect = $('#vip-cancel-reason', modals.confirm);
      var reasonId     = reasonSelect && reasonSelect.value ? Number(reasonSelect.value) : undefined;

      setBusy(btn, true);
      showError(errModal, '');
      api(apiBase, '/vip-cancel', Object.assign({}, session, {
        cancelationReasonId: reasonId,
        note: 'Self-service cancel via /pages/membership',
      }))
        .then(function (res) {
          closeAll(root);
          var endIso = res && res.endDate;
          var msg    = $('.vip-success__period', modals.success);
          if (msg && endIso) msg.textContent = 'Your access continues until ' + formatDate(endIso) + '.';
          openModal(modals.success);
          clearSession();
        })
        .catch(function (err) { showError(errModal, err.message); })
        .then(function () { setBusy(btn, false); });
    }

    /* ── Step 4 success → buttons ───────────────────────────────────────── */
    on($('#vip-success-home',    modals.success), 'click', function () { window.location.href = '/'; });
    on($('#vip-success-support', modals.success), 'click', function () {
      var supportHref = root.getAttribute('data-support-url') || 'mailto:support@savvysmartdeals.com';
      window.location.href = supportHref;
    });

    /* ── Offer accepted / membership kept → button ─────────────────────── */
    on($('#vip-kept-home', modals.kept), 'click', function () { window.location.href = '/'; });

    /* ── Error screen (membership not found) → buttons ──────────────────── */
    on($('#vip-error-support', modals.error), 'click', function () {
      var supportHref = root.getAttribute('data-support-url') || 'mailto:support@savvysmartdeals.com';
      window.location.href = supportHref;
    });
    on($('#vip-error-home', modals.error), 'click', function () { window.location.href = '/'; });

    /* ── Trigger entry point ────────────────────────────────────────────── */
    function currentSession() {
      var mode = trigger.getAttribute('data-mode');
      if (mode === 'session') {
        // Logged-in path — Liquid HMAC is fresh per-render.
        return {
          email: trigger.getAttribute('data-email'),
          ts:    Number(trigger.getAttribute('data-ts')),
          sig:   trigger.getAttribute('data-sig'),
        };
      }
      return readSession();
    }

    on(trigger, 'click', function (e) {
      var session = currentSession();
      if (session && session.email && session.sig) {
        e.preventDefault();
        openModal(modals.entry);
        return;
      }
      // Guest: the trigger is a Shopify-login link — let the browser follow it.
      if (trigger.tagName === 'A' && trigger.getAttribute('href')) return;
      // Legacy fallback (no login link rendered): use the magic-link modal.
      e.preventDefault();
      openModal(modals.login);
    });

    /* ── Auto-open the flow after returning from Shopify login ──────────── */
    (function handleCancelReturn() {
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.get('vip_cancel') !== '1') return;
        url.searchParams.delete('vip_cancel');
        history.replaceState({}, '', url.toString());
        var session = currentSession();
        if (session && session.email && session.sig) openModal(modals.entry);
      } catch (e) { /* noop */ }
    })();

    /* ── Pick up magic-link callback from URL: ?vip_token=... ───────────── */
    (function handleMagicLinkReturn() {
      try {
        var url    = new URL(window.location.href);
        var token  = url.searchParams.get(TOKEN_QS);
        if (!token) return;
        url.searchParams.delete(TOKEN_QS);
        history.replaceState({}, '', url.toString());

        api(apiBase, '/vip-magic-link-verify', { token: token })
          .then(function (s) {
            if (!s || !s.ok) throw new Error(s && s.error || 'Verification failed');
            writeSession({ email: s.email, exp: s.exp, sig: s.sig });
            openModal(modals.entry);
          })
          .catch(function (err) {
            console.warn('[vip-cancel] magic-link verify failed:', err.message);
            openModal(modals.login);
            showError(modals.login, err.message);
          });
      } catch (e) { /* noop */ }
    })();
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    $$('[data-vip-cancel-root]').forEach(function (root) { init(root); });
  });
})();
